import { createSlice } from "@reduxjs/toolkit";

export const  dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: [],
    reducers: {
        setUserHistory(state, action) {
            state = action.payload;
            return state;
        },
        deleteHistory(state, action) {
            state = state.filter((s) => s.doc_id !== action.payload);
            return state;
        }
    }
});

export const { setUserHistory, deleteHistory } = dashboardSlice.actions;
export default dashboardSlice.reducer;